module.exports = __webpack_public_path__ + "img/july.7193dd03.png";